import styled from "styled-components"
import { COLORS, avatars } from "../constants"
import lion from "../assets/images/lion_avatar.svg"
import { useHistory } from "react-router-dom"
import { CustomButton } from "../components"
import { Link } from "react-router-dom"
import axios from "axios"

const StyledChildCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 10px;
    border: 3px solid #EEEEEE;
    padding: 20px 0;
    height: 100%;
`;
const StyledCardWrapper = styled.div`
    padding: 5px;
    height: 250px;
`;
export function ChildCard({ name, uid, avatar }) {
    const history = useHistory();
    const api = process.env.REACT_APP_API_URL;

    const loginToChild = () => {
        axios.get(`${api}/cp/pupil/${uid}`, {}, {
        }).then(res => {

            const result = res.data.pupil_id[0];

            if (result.password) {
                history.replace('/transfer', { uid: uid, password: result.password });
            }

        }).catch(error => {
            console.log(error)
        });

    }
    return (
        <StyledCardWrapper className="grid-card">
            <StyledChildCard>
                <img src={avatars[avatar].image} width="90" alt="Chid Avatar" />
                <h6 className="mt-2" style={{ color: COLORS.text_dark_blue }}>{name}</h6>
                <div className="d-flex align-items-center">
                    <span className="d-inline-block color-text-grey mr-1">ID</span>
                    <span className="color-text-grey">•</span>
                    <span className="ml-1 color-text-green d-inline-block" style={{ fontSize: 20 }}>{uid}</span>
                </div>
                <div className="d-flex flex-wrap align-items-center justify-content-center">
                    <Link to={`/dashboard/child/${uid}`}>
                        <CustomButton className="mt-2" bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.text_green} style={{ height: 35, padding: "0px 10px" }}>My Details</CustomButton>
                    </Link>
                    <CustomButton onClick={loginToChild} className="mt-2" bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 35, padding: "0px 10px", marginLeft: 10 }}>Log In</CustomButton>
                </div>
            </StyledChildCard>
        </StyledCardWrapper>
    );
}